import Model from '../../model/model';
import RefBooksList from './refbooks.list';
import Sticker from '../../model/sticker';
import Stickers from '../../collection/refbooks/stickers';
import StickerForm from './stickers.form';

import Config from '../../config';

import { ask, } from '../../utils/popups';





const FilterModel = Model.extend( { defaults: {
    cluster: undefined,
} } )

export default RefBooksList.extend( { 

    template: 'module/refbooks/stickers.list',

    url() {
        return 'stickers';
    },

    open() {
        const makeDisableUpdateDedelePredicate = privilegeCode => 
            () =>
                !Config.privileges().includes( privilegeCode ) ||
                !['GLOBAL', 'CLUSTER'].includes( Config.level() ) ||

                // Роль уровня кластера может редактировать/удалять только сущности своего кластера;
                // в списке уже только "мои" сущности, но с примесью глобальных;
                // поэтому достаточно только запретить редактировать глобальные
                Config.level() === 'CLUSTER' && 
                    !this.options.paged.current().get( 'cluster' );

        const actions = this.options.actions = {
            
            defaults: 'edit',
            
            create: {
                
                disabled: () =>
                    !Config.privileges().includes( 'create_sticker' ) ||
                    !['GLOBAL', 'CLUSTER'].includes( Config.level() ),

                handler: () => 
                    this.trigger( StickerForm.OPEN_STICKER, 
                        new Sticker(),
                        this.state().cluster ),

            },

            edit: {

                disabled: 
                    !Config.privileges().includes( 'update_sticker' ) ||
                    !['GLOBAL', 'CLUSTER'].includes( Config.level() ),

                handler: current =>
                    this.trigger( StickerForm.OPEN_STICKER, current.clone() ),

            },
                
            destroy: {

                disabled: makeDisableUpdateDedelePredicate( 'delete_sticker' ),

                handler: current =>
                    this.destroy( current, 
                        'sticker::modal delete - title', 
                        'sticker::modal delete - confirmation text' ),
            },
            
        };

        this.options.filter = new FilterModel( { 
            cluster: this.state().cluster,
        } )

        this.options.source = new Stickers( this.options.stickers.models );
        this.options.sorted = new Stickers();
        this.options.filtered = new Stickers();
        this.options.paged = new Stickers( { actions, } );

        return this.sort().then( () => this.bind( this.options.filter ) );
    },

} );



// WEBPACK FOOTER //
// ./src/js/module/refbooks/stickers.list.js